'use client';

// AUTO-GENERATED FILE - DO NOT EDIT DIRECTLY
// See generation source in nimble-react/build/generate-icons

import { IconCircleBroken, iconCircleBrokenTag } from '@ni/nimble-components/dist/esm/icons/circle-broken';
import { wrap } from '../../utilities/react-wrapper';

export type { IconCircleBroken };
export { iconCircleBrokenTag };
export const NimbleIconCircleBroken = wrap(IconCircleBroken);